<template>
  <v-flex xs12>
    <v-card >
      <v-flex xs12 pt-4 px-4 v-if="err">
        <v-alert type="error" :value="true">{{err}}</v-alert>
      </v-flex>
      <v-card-title class="pb-3 px-2 layout row wrap">
        <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "newWebSpace" })'>{{$lang.actions.createWebSpace}}</v-btn>
        <v-checkbox
          color="primary"
          class="mx-1 mt-0"
          :label="$lang.labels.showActive"
          v-model="showActive"
          hide-details
        />
        <v-spacer/>
        <v-autocomplete
          class="min-w max-w mx-3 pb-2"
          :label="$lang.actions.selectCompany"
          :items="mappedCompanies"
          :loading="companyLoading"
          v-model="selectedCompany"
          hide-details
        />
        <v-text-field
          v-if="show"
          class="min-w max-w mx-3 pb-2"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details
        />
      </v-card-title>
      <v-data-table
        v-if="show"
        :headers="headers"
        :items="showActive ? activeWebSpaces : allWebSpaces"
        :search="search"
        :loading="loading"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
        <template slot="items" slot-scope="props">
          <td>{{ props.item.domainNameType }}</td>
          <td class="text-xs-left min-w">{{ props.item.companyName }}</td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">{{ props.item.template }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="text-xs-left">{{ formatDate(props.item.createdOn) }}</td>            
          <td class="text-xs-left min-w-lg">
            <v-btn 
              class="primary mx-0 elevation-1" 
              @click="editWebSpace(props.item)">
              {{$lang.actions.edit}}
            </v-btn>
            <v-btn 
              class="primary elevation-1"
              @click="changeStatus(props.item)">
              {{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="warning" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <v-dialog v-if="confirmationModal" v-model="confirmationModal" max-width="500">
      <confirmation-modal :data="confirmationData" @close="confirmationModal = false" @change="deactivate($event)"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    components: {
      confirmationModal: () => import('../modals/DeactivationModal'),
    },
    data() {
      return {
        err: '',
        search: '',
        show: false,
        loading: true,
        companies: [],
        selectedCompany: '',
        companyLoading: true,
        headers: [
          {text: this.$lang.header.domain, value: 'domainNameType', align: 'left',},
          {text: this.$lang.labels.company, value: 'companyName', align: 'left',},
          {text: this.$lang.header.templateType, value: 'type', align: 'left',},
          {text: this.$lang.header.templateName, value: 'template', align: 'left',},
          {text: this.$lang.labels.status, value: 'status', align: 'left',},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left',},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        showActive: true,
        allWebSpaces: [],
        confirmationModal: false,
        confirmationData: {
          id: null,
          url: 'webspace',
        },
      };
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.fetchWebSpacesforCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeWebSpaces() {
        const webSpaces = this.allWebSpaces;
        const activeWebSpaces = [];
        for (let i=0; webSpaces.length > i; i++) {
          if (webSpaces[i].status === 'active') {
            activeWebSpaces.push(webSpaces[i]);
          }
        }
        return activeWebSpaces;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      editWebSpace(webspace) {
        this.$router.push({ name: 'editWebSpace', params: { id: webspace.id }});
      },
      changeStatus(webspace) {
        if (webspace.status === 'inactive') {
          this.$http.post(`webspace/activate/${webspace.id}`)
          .then((res) => {
            if (res.body.status === 'Success') {          
              this.$set(webspace, 'status', 'active');
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
        } else if (webspace.status === "active") {
          this.confirmationData.id = webspace.id;
          this.confirmationModal = true;
        }
      },
      deactivate(id) {
        const result = this.allWebSpaces.find( data => data.id === id );
        this.$set(result, 'status', 'inactive');
      },
      init() {
        return new Promise((resolve) => {
            this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      fetchWebSpacesforCompany(id) {
        this.show = true;
        this.allWebSpaces = [];
        this.activeWebSpaces = [];
        this.$http.post('webspace/getall', { companyId: id })
        .then((res) => {
          this.loading = false;
          if (res.body.status === 'Success') {
            this.allWebSpaces = res.body.webSpaces;
            return;
          }
          if (this.allWebSpaces.length === 0) {
            this.loading = false;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.loading = false;
          this.err = err.body.statusText || err.body.message;
        });
      },
    },
    created() {
      this.init()
        .then(() => {
          const edit = this.$cookie.get('companyedit');
          if (edit) this.selectedCompany = edit;
        });
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// WebSpaces.vue?4e29f952